import { render, staticRenderFns } from "./SearchBoxEmptyState.vue?vue&type=template&id=83983632&"
import script from "./SearchBoxEmptyState.vue?vue&type=script&lang=ts&"
export * from "./SearchBoxEmptyState.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports